export function BrandMark({ size = 26 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path fill="currentColor" d="M11.35 5.35 21 2v6.3c0 1.75-.99 3.35-2.56 4.13l-7.09 3.55V5.35Z" />
    <path fill="currentColor" d="M12.65 18.65 3 22v-6.3c0-1.75.99-3.35 2.56-4.13l7.09-3.55v10.63Z" />
  </svg>;
}
